import React from 'react';
import { ScrollRestoration } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import PageHero from './PageHero';
import ProductCard from './ProductCard';
import FormularDoprava from './FormularDoprava';
import ivecodaily35 from '../resources/Ivecodaily35.jpg';
import ivecodaily35A from '../resources/Ivecodaily35t.jpg';
import UNC753 from '../resources/UNC753.jpg';
import MercedesAxor from '../resources/MercedesAxor.jpg';
import MercedesAtego from '../resources/MercedesAtego.jpg';
import bagerYanmar from '../resources/BagerYANMAR.jpg';
import valecBomag from '../resources/ValecBomagBW80.jpg';

const cards = [
    {
        img: ivecodaily35,
        badge: 'Iveco',
        title: 'Iveco Daily do 3,5t',
        description: '',
        tableRows: [
            { label: 'Preprava do 5 km', bezDph: '10,98 €', sDph: '13,50 €' },
            { label: 'Cena za 1 km', bezDph: '1,14 €', sDph: '1,40 €' },
            { label: 'Nákladka + výkladka', bezDph: '4,55 €', sDph: '5,60 €' },
        ],
    },
    {
        img: ivecodaily35A,
        badge: 'Iveco',
        title: 'Iveco Daily nad 3,5t',
        description: '',
        tableRows: [
            { label: 'Preprava do 5 km', bezDph: '11,63 €', sDph: '14,30 €' },
            { label: 'Cena za 1 km', bezDph: '1,22 €', sDph: '1,50 €' },
            { label: 'Nákladka + výkladka', bezDph: '5,00 €', sDph: '6,15 €' },
        ],
    },
    {
        img: MercedesAxor,
        badge: 'Mercedes',
        title: 'Mercedes Axor nad 7,5t',
        description: '',
        tableRows: [
            { label: 'Preprava do 5 km', bezDph: '13,01 €', sDph: '16,00 €' },
            { label: 'Cena za 1 km', bezDph: '1,50 €', sDph: '1,85 €' },
            { label: 'Nákladka + výkladka', bezDph: '5,28 €', sDph: '6,50 €' },
        ],
    },
    {
        img: MercedesAtego,
        badge: 'Mercedes',
        title: 'Mercedes Atego nad 3,5t',
        description: '',
        tableRows: [
            { label: 'Preprava do 5 km', bezDph: '11,63 €', sDph: '14,30 €' },
            { label: 'Cena za 1 km', bezDph: '1,22 €', sDph: '1,50 €' },
            { label: 'Nákladka + výkladka', bezDph: '5,00 €', sDph: '6,15 €' },
        ],
    },
    {
        img: MercedesAxor,
        badge: 'Mercedes',
        title: 'Mercedes Axor hydraulická ruka',
        description: '',
        tableRows: [
            { label: 'Cena za 1 km', bezDph: '1,50 €', sDph: '1,85 €' },
            { label: 'Nákladka + výkladka (paleta)', bezDph: '4,23 €', sDph: '5,20 €' },
        ],
    },
    {
        img: bagerYanmar,
        badge: 'Bager YANMAR',
        title: 'Bager YANMAR zemné práce',
        description: '',
        tableRows: [
            { label: 'Cena za 1 h', bezDph: '23,98 €', sDph: '29,50 €' },
        ],
    },
    {
        img: bagerYanmar,
        badge: 'Bager YANMAR',
        title: 'Bager YANMAR búracie kladivo',
        description: '',
        tableRows: [
            { label: 'Cena za 1 h', bezDph: '26,02 €', sDph: '32,00 €' },
        ],
    },
    {
        img: UNC753,
        badge: 'UNC',
        title: 'UNC 753',
        description: '',
        tableRows: [
            { label: 'Cena za 1 h', bezDph: '26,02 €', sDph: '32,00 €' },
        ],
    },
    {
        img: valecBomag,
        badge: 'Valec Bomag',
        title: 'Valec Bomag BW 80 s obsluhou',
        description: '',
        tableRows: [
            { label: 'Cena za 1 h', bezDph: '23,98 €', sDph: '29,50 €' },
        ],
    },
];

function Doprava() {
    return (
        <div>
            <Navbar />
            <PageHero
                title="Naša"
                highlight="doprava"
                subtitle="Vlastné vozidlá a stroje – rýchla a spoľahlivá preprava materiálu."
            />
            <div className="max-w-screen-xl mx-auto px-6 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                {cards.map((card, i) => (
                    <ProductCard key={i} {...card} />
                ))}
            </div>
            <FormularDoprava />
            <Footer />
            <ScrollRestoration />
        </div>
    );
}

export default Doprava;
